var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxCal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b450ddae-d344-420d-a4a5-9fd0185d70ef",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "bc8fbad9-0711-4109-8e37-50c4aaa96c67",
    "data-name": "Path 67",
    d: "M14.437,4.7H13.152V4.529a.661.661,0,1,0-1.321,0V4.7H8.171v-.17a.661.661,0,1,0-1.321,0V4.7H5.564A2.447,2.447,0,0,0,3.12,7.144v6.544a2.448,2.448,0,0,0,2.444,2.444h8.872a2.448,2.448,0,0,0,2.444-2.444V7.144A2.447,2.447,0,0,0,14.437,4.7m1.123,8.988a1.125,1.125,0,0,1-1.123,1.123H5.564a1.125,1.125,0,0,1-1.123-1.123V7.144A1.125,1.125,0,0,1,5.564,6.021H6.85v.227a.661.661,0,0,0,1.321,0V6.021h3.66v.227a.661.661,0,0,0,1.321,0V6.021h1.285A1.125,1.125,0,0,1,15.56,7.144Z",
    style: {
      fill: "#005a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e97721bf-5f27-4b93-8db3-6d99865e49c8",
    "data-name": "Path 68",
    d: "M12.817,8.486H6.99a.661.661,0,1,0,0,1.321h5.826a.661.661,0,1,0,0-1.321",
    style: {
      fill: "#005a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2a03471-7e2b-4eae-947f-d201247415fe",
    "data-name": "Path 69",
    d: "M12.817,11.047H6.99a.661.661,0,1,0,0,1.321h5.826a.661.661,0,1,0,0-1.321",
    style: {
      fill: "#005a7d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCal);
export default __webpack_public_path__ + "static/media/bxCal.6a7d830ba361a61ff4ea6a6a229d4036.svg";
export { ForwardRef as ReactComponent };